import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './MainPanel.css';

import ManageSlots from './tabs/ManageSlots/ManageSlots';
// import UserUpdate from './tabs/UserUpdate';
// import ClinicSettings from './tabs/ClinicSettings';

const MainPanel = ({user}) => {
  return (
    <section className="main-panel">
      <Routes>
        <Route index element={<Navigate to="manage-slots" />} />
        <Route path="manage-slots" element={<ManageSlots user={user} />} />
        {/* <Route path="user-update" element={<UserUpdate />} />
        <Route path="clinic-settings" element={<ClinicSettings />} /> */}
      </Routes>
    </section>
  );
};

export default MainPanel;
